import "./LocationUserViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationUserViewComponent from "./location-user-view/LocationUserViewComponent";
import LocationUserEditComponent from "./location-user-edit/LocationUserEditComponent";

interface LocationUserViewEditComponentProps {
    locationDetails: any
    onUpdateAdminDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const LocationUserViewEditComponent = (props: LocationUserViewEditComponentProps) => {
    const {locationDetails, onModeChange, canEdit, onUpdateAdminDetails} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");

    const handleLocationDetailsUpdate = useCallback((updatedUserDetailsList: any) => {
        onUpdateAdminDetails((prev: any) => {
            return {
                ...prev,
                userDetails: updatedUserDetailsList
            }
        })
    }, [onUpdateAdminDetails]);

    const handleLocationDetailsEditCancel = useCallback((updatedUserDetailsList: any) => {
        onUpdateAdminDetails((prev: any) => {
            return {
                ...prev,
                userDetails: updatedUserDetailsList
            }
        })
        setMode("view");
    }, [onUpdateAdminDetails]);

    useEffect(() => {
        onModeChange(mode);
    }, [mode, onModeChange]);
    return (
        <div className={'location-user-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationUserViewComponent
                    userList={locationDetails?.userDetails || []}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                    onUpdateComplete={handleLocationDetailsUpdate}
                />
            }
            {
                mode === "edit" && <LocationUserEditComponent
                    userDetailsList={locationDetails?.userDetails || []}
                    locationId={locationDetails.id}
                    onUpdateComplete={handleLocationDetailsUpdate}
                    onEditCancel={handleLocationDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LocationUserViewEditComponent;
